import React from "react";

import SupplierProductView from "../../containers/SupplierDetail/SupplierProductView";

const ProductsSearchPage = () => {
  return (
    <div>
      <SupplierProductView />
    </div>
  );
};

export default ProductsSearchPage;
